import { APIDescriptor } from "../../types";

const baseUrl: string = "/products/third-party-apis/nibss";

const nibssDescriptors: APIDescriptor[] = [
    {
        name: "Combined Identity Validation",
        description: "Validate customer identity across NIN, VNIN, TIN, document number, and phone number through a single unified API",
        path: "/combined-identity-validation",
        categories: [{ label: "NIBSS APIs" }]
    },
    {
        name: "Phone Number Validation",
        description: "Fetch and verify customer details linked to a phone number from ICAD and BVN records",
        path: "/phone-number-validation",
        categories: [{ label: "NIBSS APIs" }]
    },
    {
        name: "Virtual NIN",
        description: "Retrieve and verify virtual NIN information generated by customers through the NIMC app",
        path: "/virtual-nin",
        categories: [{ label: "NIBSS APIs" }]
    },
    {
        name: "TIN Verification",
        description: "Verify individual and corporate Tax Identification Numbers against FIRS records",
        path: "/tin-verification",
        categories: [{ label: "NIBSS APIs" }]
    },
    {
        name: "Core Banking Application",
        description: "Access core banking application services and data through the NIBSS infrastructure",
        path: "/core-banking-application",
        categories: [{ label: "NIBSS APIs" }]
    },
    {
        name: "iGree USSD",
        description: "Integrate NIBSS iGree consent management services via USSD for customer authorization flows",
        path: "/igree-ussd",
        categories: [{ label: "NIBSS APIs" }]
    },
]

export const nibssApiDescriptors = nibssDescriptors.map((desc) => ({ ...desc, path: baseUrl + desc.path }))